
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 24C5.391 24 0 18.622 0 12 0 5.391 5.378 0 12 0c6.608 0 12 5.378 12 12s-5.378 12-12 12zm0-21.474c-5.221 0-9.474 4.253-9.474 9.474S6.779 21.474 12 21.474s9.474-4.253 9.474-9.474c.014-5.221-4.24-9.474-9.474-9.474z","fill":"#ABE6FF"}}),_c('path',{attrs:{"d":"M3.193 10.837l7.125 7.378L24.251 4.759l-2.325-2.407-11.525 11.13-4.8-4.97-2.408 2.325z","fill":"#FA6400"}})])
          )
        }
      }
    